import React, { useEffect, useState } from "react";
import { Form, useNavigate, useParams } from "react-router-dom";
import API_URL from "../../config/config";
import axios from "axios";
import {
  Box,
  Button,
  // CheckBox,
  Heading,
  Text,
  // Table,
  Notification,
  DateInput,
  FormField,
  MaskedInput,
  // Layer,
} from "grommet";
// import { LinkPrevious } from "grommet-icons";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import BreadcrumbHeader from "../../components/ManagerPortal/BreadcrumbHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import moment from "moment-timezone";
// import HeaderComponent from "../../components/ManagerPortal/HeaderComponent";

const EditCreatedAssessment = () => {
  const navigate = useNavigate();
  const { manager_id, assessment_id } = useParams();

  // MAIN STATES
  const [users, setUsers] = useState([]);
  const [assessmentDetails, setAssessmentDetails] = useState({});
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(true);
  const [error, setError] = useState("");
  const [notification, setNotification] = useState(null);
  const [dueDate, setDueDate] = useState(""); // Store assessment due date
  const [dueTime, setDueTime] = useState(""); // Store assessment due time
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChanged, setIsChanged] = useState(false); // State to track changes

  // const [userToRemove, setUserToRemove] = useState(null);
  useEffect(() => {
    fetchAssessmentDetails();
    fetchUsersAndGroups();
  }, []);
  useEffect(() => {
    fetchAssessmentDetails();
    fetchUsersAndGroups();
  }, [setSelectedUsers, setAssessmentDetails]);

  const handleNameChange = (event) => {
    const value = event.target.value;
    if (value.trim() === "") {
      setError("Assessment name cannot be empty");
    } else {
      setError("");
    }

    setAssessmentDetails((prev) => {
      const newDetails = { ...prev, name: value };
      setIsChanged(
        JSON.stringify(newDetails) !== JSON.stringify(assessmentDetails),
      ); // Check if any changes are made
      return newDetails;
    });
  };

  const fetchAssessmentDetails = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/manager/get_assessment_details/${assessment_id}`,
      );

      var new_due_by = String(response.data.assessmentDetails[0].due_by);
      const userTimeZone = moment.tz.guess();
      if (
        response.data.assessmentDetails[0].tz !== null &&
        response.data.assessmentDetails[0].tz !== userTimeZone
      ) {
        // If the received timezone (tz) is different from the user's timezone
        // Convert the due_by field to the user's timezone
        const convertedDueBy = moment
          .tz(
            response.data.assessmentDetails[0].due_by,
            response.data.assessmentDetails[0].tz,
          )
          .clone()
          .tz(userTimeZone)
          .format("YYYY-MM-DD HH:mm:ss"); // Format to match your display format
        new_due_by = convertedDueBy;
      }
      setDueDate(String(String(new_due_by).split(" ")[0]));
      setDueTime(String(new_due_by).split(" ")[1].slice(0, 5));
      setAssessmentDetails(response.data.assessmentDetails[0]);
      setIsChanged(false); // Initially no changes made
    } catch (err) {
      console.error("Error fetching assessment details:", err);
      setNotification({
        message: "Failed to fetch assessment details.",
        status: "critical",
      });
    }
  };

  const fetchUsersAndGroups = async () => {
    try {
      const userResponse = await axios.get(
        `${API_URL}/manager/get_invited_users_status/${manager_id}`,
      );
      const usersSelectedForAssessment = await axios.get(
        `${API_URL}/manager/get_selected_users/${assessment_id}`,
      );
      const usersAlreadySelected =
        usersSelectedForAssessment.data.invites || [];
      const fetchedUsers = userResponse.data.invites || [];
      const selectedUserIds = usersAlreadySelected.map((user) => user.user_id);
      setSelectedUsers(selectedUserIds);
      setUsers(fetchedUsers);
      setIsLoadingUsers(false);
    } catch (err) {
      console.error("Error fetching users and groups:", err);
      setError("Failed to fetch users and groups. Please try again.");
      setNotification({
        message: "Failed to fetch users and groups.",
        status: "critical",
      });
      setIsLoadingUsers(false);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    // Validate assessment name
    if (!assessmentDetails.name.trim()) {
      setError("Assessment name cannot be empty.");
      setNotification({
        message: "Assessment name cannot be empty.",
        status: "critical",
      });
      return;
    }
    const newdueDate = dueDate.split(" ")[0];
    // Validate due date and time
    if (!newdueDate || !dueTime) {
      setError("Both due date and time are required.");
      setNotification({
        message: "Both due date and time are required.",
        status: "critical",
      });
      return;
    }
    const dateTime = `${newdueDate} ${dueTime}:00`; // Combine date and time with seconds
    const selectedDateTime = new Date(dateTime);
    const now = new Date();

    if (isNaN(selectedDateTime.getTime())) {
      setError("Invalid due date or time.");
      setNotification({
        message: "Invalid due date or time.",
        status: "critical",
      });
      return;
    }

    if (selectedDateTime < now) {
      setError("Due date/time cannot be in the past.");
      setNotification({
        message: "Due date/time cannot be in the past.",
        status: "critical",
      });
      return;
    }

    try {
      await axios.post(`${API_URL}/manager/update_assessment_details/`, {
        manager_id,
        assessment_id,
        name: assessmentDetails.name,
        due_by: dateTime,
        tz: moment.tz.guess(),
      });

      setNotification({
        message: "Assessment updated successfully!",
        status: "normal",
      });

      // Delay navigation to allow toast to be visible
      setTimeout(() => {
        navigate(`/${manager_id}/manager/assessments/`);
      }, 2000); // Adjust the delay as needed
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error submitting selection:", error);
      setError("Failed to submit selection. Please try again.");
      setNotification({
        message: "Failed to submit selection. Please try again.",
        status: "critical",
      });
    }
  };

  return (
    <Box fill="vertical">
      {/* Header Navigation */}
      <HeaderNavigation />
      {/* <HeaderComponent current={"Modify Assessment"} previous={"Assessments dashboard"} previous_link_name={"assessments"} color_modify={0} required={0}/> */}
      <BreadcrumbHeader title1="Manage Assessments" title2="Edit Assessment" />
      {/* Notification */}
      <Box flex="grow" pad="medium" gap="medium">
        {error && (
          <Box background="status-critical" pad="small" round="small">
            <Text>{error}</Text>
          </Box>
        )}

        {/* Assessment Details */}
        {assessmentDetails && (
          <Box>
            <Heading level="2" margin={{ top: "small" }}>
              Assessment Name - {assessmentDetails.name}
            </Heading>
            <Box
              pad="medium"
              round="medium"
              elevation="none" // Removes unnecessary elevation
              width="auto" // Ensures full width alignment
              background="light-1"
              style={{ maxWidth: "400px" }}
            >
              <Box
                direction="column"
                gap="medium"
                align="start"
                justify="between"
                // fill="horizontal"
                margin={{ top: "small" }}
              >
                {/* Due Date Field */}
                <Box>
                  <FormField label="Edit Due By Date">
                    <DateInput
                      format="yyyy-mm-dd"
                      value={dueDate}
                      onChange={({ value }) => {
                        const formattedDate = Array.isArray(value)
                          ? new Date(value[0]).toLocaleDateString("en-CA")
                          : new Date(value).toLocaleDateString("en-CA");
                        setDueDate(formattedDate);
                        setIsChanged(true);
                      }}
                      calendarProps={{ range: false }}
                      min={new Date().toLocaleDateString("en-CA")}
                      dropAlign={{ top: "bottom", left: "left" }}
                    />
                  </FormField>
                </Box>

                {/* Due Time Field */}
                <Box>
                  <FormField label="Edit Due By Time">
                    <MaskedInput
                      mask={[
                        {
                          length: [1, 2],
                          options: Array.from({ length: 24 }, (v, k) =>
                            k.toString().padStart(2, "0"),
                          ),
                          placeholder: "hh",
                        },
                        { fixed: ":" },
                        {
                          length: 2,
                          options: ["00", "15", "30", "45"],
                          placeholder: "mm",
                        },
                      ]}
                      value={dueTime}
                      onChange={(event) => {
                        setDueTime(event.target.value);
                        setIsChanged(true);
                      }}
                      placeholder="HH:MM"
                    />
                  </FormField>
                </Box>
              </Box>
              <Box pad="medium" align="start">
                <Button
                  label="Finish editing"
                  onClick={handleSubmit}
                  primary
                  disabled={!isChanged || isSubmitting}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      {/* Main Body */}

      <StickyFooter />
      {notification && (
        <Notification
          toast
          message={notification.message}
          status={notification.status}
          onClose={() => setNotification(null)}
        />
      )}
    </Box>
  );
};

export default EditCreatedAssessment;
